var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 151.506,
    height: 170.063,
    viewBox: "0 0 151.506 170.063",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "food-blogger",
    transform: "translate(-27.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5481",
    "data-name": "Group 5481",
    transform: "translate(68.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5479",
    "data-name": "Group 5479",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7413",
    "data-name": "Path 7413",
    d: "M212.974,12.1A35.434,35.434,0,0,0,185.781,0C174.4,0,169.51,1.873,164.931,3.986S160.045,15.3,160.045,15.3a34.8,34.8,0,0,0-9.188,23.606V48.9H220.7V38.91c0-7.643-1.159-19.4-7.73-26.812Z",
    transform: "translate(-150.857)",
    fill: "#010300"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5480",
    "data-name": "Group 5480",
    transform: "translate(0 2.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7414",
    "data-name": "Path 7414",
    d: "M171.312,32.157c-6.537-8.022-6.919-20.7-2.294-25.255-1.48.521-2.8,1.1-4.087,1.694-4.579,2.113-4.885,11.317-4.885,11.317a34.8,34.8,0,0,0-9.188,23.606v9.99h20.455Z",
    transform: "translate(-150.857 -6.902)",
    fill: "#010300"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5482",
    "data-name": "Group 5482",
    transform: "translate(36.942 104.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7415",
    "data-name": "Path 7415",
    d: "M179.445,327.151c-7.777-6.867-41.05-12.434-41.909-12.576H106.058c-.858.142-34.132,5.71-41.909,12.576-2.774,2.449-6.035,9.745-9.1,18.17a81.369,81.369,0,0,0,133.492,0C185.48,336.9,182.219,329.6,179.445,327.151Z",
    transform: "translate(-55.051 -314.575)",
    fill: "#d81212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5483",
    "data-name": "Group 5483",
    transform: "translate(83.018 104.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7416",
    "data-name": "Path 7416",
    d: "M235.131,315.469c-2.874-.547-4.755-.861-4.951-.894H198.7c-.195.032-2.067.345-4.93.89.663.884,8.345,10.766,20.6,10.766C226.746,326.231,234.6,316.172,235.131,315.469Z",
    transform: "translate(-193.771 -314.575)",
    fill: "#d81212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5484",
    "data-name": "Group 5484",
    transform: "translate(87.948 73.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7417",
    "data-name": "Path 7417",
    d: "M240.093,220.734H208.614V251.9s6.318,6.674,15.668,6.674,15.811-6.674,15.811-6.674Z",
    transform: "translate(-208.614 -220.734)",
    fill: "#f0b38e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486",
    transform: "translate(36.942 108.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7419",
    "data-name": "Path 7419",
    d: "M84.878,328.024c-8.554,2.189-17.227,5.017-20.729,8.109-2.774,2.449-6.035,9.745-9.1,18.169a81.267,81.267,0,0,0,66.746,34.83C87.744,369.635,84.951,329.178,84.878,328.024Z",
    transform: "translate(-55.051 -328.024)",
    fill: "#d81212"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5487",
    "data-name": "Group 5487",
    transform: "translate(126.069 46.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7420",
    "data-name": "Path 7420",
    d: "M325.932,146.01s3.449-8.4,9.6-6.449-.149,20.15-12.148,21.3Z",
    transform: "translate(-323.382 -139.268)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5488",
    "data-name": "Group 5488",
    transform: "translate(66.767 46.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7421",
    "data-name": "Path 7421",
    d: "M156.834,146.01s-3.449-8.4-9.6-6.449.149,20.15,12.148,21.3Z",
    transform: "translate(-144.844 -139.268)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489",
    transform: "translate(74.591 27.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7422",
    "data-name": "Path 7422",
    d: "M205.344,87.172l4.08,4.817a1.33,1.33,0,0,1-1.206,2.175c-18.358-2.671-24.813-11.23-24.813-11.23-5.219,2.476-7.7,8.588-9.508,13.891a10.393,10.393,0,0,1-5.475,6.077l0,0c-.01.409-.016.819-.016,1.233,0,21.426,13.027,46.553,29.1,46.553s29.1-25.128,29.1-46.553c0-.413-.007-.823-.016-1.232a59.26,59.26,0,0,0-21.232-15.728Z",
    transform: "translate(-168.401 -82.934)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5491",
    "data-name": "Group 5491",
    transform: "translate(48.906 139.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7424",
    "data-name": "Path 7424",
    d: "M91.07,423.24v7.084a81.806,81.806,0,0,0,7.506,6.066l-4-13.653A1.79,1.79,0,0,0,91.07,423.24Z",
    transform: "translate(-91.07 -421.448)",
    fill: "#cc0053"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5513",
    "data-name": "Group 5513",
    transform: "translate(71.115 104.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5501",
    "data-name": "Group 5501",
    transform: "translate(3.257 38.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7432",
    "data-name": "Path 7432",
    d: "M174.384,445.286l22.673,6.643,22.673-6.643a6.643,6.643,0,0,0,0-13.286H174.384a6.643,6.643,0,0,0,0,13.286Z",
    transform: "translate(-167.741 -432)",
    fill: "#ac7752"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5503",
    "data-name": "Group 5503",
    transform: "translate(0 52.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7434",
    "data-name": "Path 7434",
    d: "M164.578,485.286h51.86a6.643,6.643,0,0,0,0-13.286h-51.86a6.643,6.643,0,0,0,0,13.286Z",
    transform: "translate(-157.935 -472)",
    fill: "#fcbc71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5506",
    "data-name": "Group 5506",
    transform: "translate(3.258 26.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5505",
    "data-name": "Group 5505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7436",
    "data-name": "Path 7436",
    d: "M172.176,408.156l.085-.042a3.441,3.441,0,0,1,4.123.856,7.057,7.057,0,0,0,10.628,0,3.441,3.441,0,0,1,4.123-.856l.083.042a3.079,3.079,0,0,0,4.068-4.2c-2.017-3.817-6.075-8.746-13.589-8.746s-11.573,4.93-13.588,8.747A3.079,3.079,0,0,0,172.176,408.156Z",
    transform: "translate(-167.742 -395.209)",
    fill: "#65d33c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5508",
    "data-name": "Group 5508",
    transform: "translate(33.976 26.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5507",
    "data-name": "Group 5507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7437",
    "data-name": "Path 7437",
    d: "M283.7,408.156l-.085-.042a3.441,3.441,0,0,0-4.123.856,7.057,7.057,0,0,1-10.628,0,3.441,3.441,0,0,0-4.123-.856l-.083.042a3.079,3.079,0,0,1-4.068-4.2c2.017-3.817,6.075-8.746,13.589-8.746s11.573,4.93,13.588,8.747A3.079,3.079,0,0,1,283.7,408.156Z",
    transform: "translate(-260.225 -395.209)",
    fill: "#65d33c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5509",
    "data-name": "Group 5509",
    transform: "translate(18.617 31.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7438",
    "data-name": "Path 7438",
    d: "M237.46,422.866l-.085-.042a3.441,3.441,0,0,0-4.123.856,7.057,7.057,0,0,1-10.628,0,3.441,3.441,0,0,0-4.123-.856l-.083.042a3.079,3.079,0,0,1-4.068-4.2c2.017-3.817,6.075-8.746,13.589-8.746s11.573,4.93,13.588,8.747A3.079,3.079,0,0,1,237.46,422.866Z",
    transform: "translate(-213.983 -409.918)",
    fill: "#89e56a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5511",
    "data-name": "Group 5511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5510",
    "data-name": "Group 5510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7439",
    "data-name": "Path 7439",
    d: "M219.823,351.523H161.191a3.258,3.258,0,0,1-3.257-3.257V347.9a32.573,32.573,0,0,1,65.145,0v.362A3.257,3.257,0,0,1,219.823,351.523Z",
    transform: "translate(-157.934 -315.331)",
    fill: "#fcbc71"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5514",
    "data-name": "Group 5514",
    transform: "translate(150.211 103.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7441",
    "data-name": "Path 7441",
    d: "M406.03,345.527h-9.965L397.726,311h6.643Z",
    transform: "translate(-396.065 -311)",
    fill: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5517",
    "data-name": "Group 5517",
    transform: "translate(42.218 87.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5515",
    "data-name": "Group 5515",
    transform: "translate(4.982 16.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7442",
    "data-name": "Path 7442",
    d: "M85.935,345.527H95.9L94.239,311H87.6Z",
    transform: "translate(-85.935 -311)",
    fill: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5516",
    "data-name": "Group 5516"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 9.965,
    cy: 13.286,
    rx: 9.965,
    ry: 13.286,
    fill: "#9a9a9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5518",
    "data-name": "Group 5518",
    transform: "translate(145.229 85.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7443",
    "data-name": "Path 7443",
    d: "M397.008,260.482v10.685a1.993,1.993,0,0,1-3.986,0V260.482a1.993,1.993,0,0,0-3.986,0v10.685a1.993,1.993,0,1,1-3.986,0V260.482a1.993,1.993,0,0,0-3.986,0V273.16c0,7.338,4.461,13.286,9.965,13.286s9.965-5.949,9.965-13.286V260.482a1.993,1.993,0,0,0-3.986,0Z",
    transform: "translate(-381.065 -258.489)",
    fill: "#9a9a9a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5525",
    "data-name": "Group 5525",
    transform: "translate(142.904 125.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5519",
    "data-name": "Group 5519",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7444",
    "data-name": "Path 7444",
    d: "M376.834,381.6a4.152,4.152,0,0,0,4.152,4.152h-2.768a4.152,4.152,0,1,0,0,8.3h2.768a4.152,4.152,0,0,0,0,8.3h2.768a4.152,4.152,0,1,0,0,8.3h10.241a16.608,16.608,0,1,0,0-33.215H380.985A4.152,4.152,0,0,0,376.834,381.6Z",
    transform: "translate(-374.066 -377.448)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5524",
    "data-name": "Group 5524",
    transform: "translate(0 2.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5520",
    "data-name": "Group 5520",
    transform: "translate(5.536 24.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7445",
    "data-name": "Path 7445",
    d: "M391.292,458.7a4.147,4.147,0,0,0,3.592,6.228h2.685a2.076,2.076,0,0,0,0-4.152h-2.685A4.146,4.146,0,0,1,391.292,458.7Z",
    transform: "translate(-390.732 -458.698)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5521",
    "data-name": "Group 5521",
    transform: "translate(2.768 16.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7446",
    "data-name": "Path 7446",
    d: "M382.959,433.7a4.147,4.147,0,0,0,3.592,6.228H392a2.076,2.076,0,1,0,0-4.152h-5.453A4.146,4.146,0,0,1,382.959,433.7Z",
    transform: "translate(-382.399 -433.698)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5522",
    "data-name": "Group 5522",
    transform: "translate(2.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7447",
    "data-name": "Path 7447",
    d: "M382.959,383.7a4.147,4.147,0,0,0,3.592,6.228H392a2.076,2.076,0,0,0,0-4.152h-5.453A4.146,4.146,0,0,1,382.959,383.7Z",
    transform: "translate(-382.399 -383.698)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5523",
    "data-name": "Group 5523",
    transform: "translate(0 8.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7448",
    "data-name": "Path 7448",
    d: "M374.625,408.7a4.147,4.147,0,0,0,3.592,6.228h8.221a2.076,2.076,0,1,0,0-4.152h-8.221A4.147,4.147,0,0,1,374.625,408.7Z",
    transform: "translate(-374.065 -408.698)",
    fill: "#fdc4a1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5532",
    "data-name": "Group 5532",
    transform: "translate(27.935 125.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5526",
    "data-name": "Group 5526",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7449",
    "data-name": "Path 7449",
    d: "M61.7,381.6a4.152,4.152,0,0,1-4.152,4.152H60.32a4.152,4.152,0,0,1,0,8.3H57.552a4.152,4.152,0,0,1,0,8.3H54.784a4.152,4.152,0,1,1,0,8.3H44.543a16.608,16.608,0,0,1,0-33.215H57.552A4.152,4.152,0,0,1,61.7,381.6Z",
    transform: "translate(-27.935 -377.448)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5531",
    "data-name": "Group 5531",
    transform: "translate(22.088 2.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5527",
    "data-name": "Group 5527",
    transform: "translate(0 24.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7450",
    "data-name": "Path 7450",
    d: "M102.788,458.7a4.147,4.147,0,0,1-3.592,6.228H96.511a2.076,2.076,0,1,1,0-4.152H99.2A4.146,4.146,0,0,0,102.788,458.7Z",
    transform: "translate(-94.435 -458.698)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5528",
    "data-name": "Group 5528",
    transform: "translate(0 16.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7451",
    "data-name": "Path 7451",
    d: "M105.555,433.7a4.147,4.147,0,0,1-3.592,6.228H96.51a2.076,2.076,0,1,1,0-4.152h5.453A4.146,4.146,0,0,0,105.555,433.7Z",
    transform: "translate(-94.434 -433.698)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5529",
    "data-name": "Group 5529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7452",
    "data-name": "Path 7452",
    d: "M105.555,383.7a4.147,4.147,0,0,1-3.592,6.228H96.51a2.076,2.076,0,0,1,0-4.152h5.453A4.146,4.146,0,0,0,105.555,383.7Z",
    transform: "translate(-94.434 -383.698)",
    fill: "#fdc4a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5530",
    "data-name": "Group 5530",
    transform: "translate(0 8.304)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7453",
    "data-name": "Path 7453",
    d: "M108.324,408.7a4.147,4.147,0,0,1-3.592,6.228H96.511a2.076,2.076,0,1,1,0-4.152h8.221A4.147,4.147,0,0,0,108.324,408.7Z",
    transform: "translate(-94.435 -408.698)",
    fill: "#fdc4a1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus15);
export default __webpack_public_path__ + "static/media/status-15.9a5c58a8528c64328b6530d007fe574d.svg";
export { ForwardRef as ReactComponent };